import moment from 'moment';

function install(Vue) {

    if (install.installed) {
        return;
    }
    install.installed = true;

    Vue.prototype.$util = {
        color: {
            /**
             * Convert hex color to rgb(a)
             *
             * @param string hex
             * @param float opacity
             * @returns {*} r,g,b,css
             */
            hexToRgb: function (hex, opacity) {
                hex = (hex + '').trim();

                let rgb = {},
                    match = hex.match(/^#?(([0-9a-zA-Z]{3}){1,3})$/);

                if (!match) {
                    return null;
                }

                hex = match[1];
                if (hex.length == 6) {
                    rgb.r = parseInt(hex.substring(0, 2), 16);
                    rgb.g = parseInt(hex.substring(2, 4), 16);
                    rgb.b = parseInt(hex.substring(4, 6), 16);
                }
                else if (hex.length == 3) {
                    rgb.r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
                    rgb.g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
                    rgb.b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
                }

                rgb.css = 'rgb' + (opacity ? 'a' : '') + '(';
                rgb.css += rgb.r + ',' + rgb.g + ',' + rgb.b;
                rgb.css += (opacity ? ',' + opacity : '') + ')';

                return rgb;
            },
        },

        date: {
            formatDate: function(date, defaultText, format) {
                if (!date) {
                    return defaultText || '';
                }

                return moment(date).format(format || 'MM/DD/YYYY');
            },

            longDate: function (date) {
                if (typeof date === 'undefined' || date === '') {
                    return '';
                }

                let format = 'MMMM Do, YYYY';

                if (typeof date === 'string') {
                    return moment(date).format(format);
                }

                return date.format(format);
            },

            trimToDate: function (date) {
                return moment(date).format('YYYY-MM-DD');
            }
        },

        img: {
            coverPhoto: function (url) {
                if (!url) {
                    return '';
                }

                let styles = 'min-width: 100%;';
                let classes = 'img-responsive';

                return '<img style="' + styles + '" class="' + classes + '" src="' + url + '"/>';
            },

            profilePicture: function (url) {
                if (!url) {
                    url = "/-/public/img/default-profile.svg";
                }

                let styles = 'min-width: 100%;';
                let classes = 'img-responsive';

                return '<img style="' + styles + '" class="' + classes + '" src="' + url + '"/>';
            },

            profilePictureBubble: function (url, size) {
                if (!url) {
                    url = "/-/public/img/default-profile.svg";
                }

                let styles = 'background:url(' + url + ') center/cover no-repeat;';
                let classes = 'profile-picture-bubble';
                if (size) {
                    classes += ' profile-picture-bubble-' + size;
                }

                return '<span style="' + styles + '" class="' + classes + '"></span>';
            },
        },

        misc: {
            copy: function(object) {
                return Object.assign({}, object);
            }
        },
    };
}

export default install;
